var _toConsumableArray = require("/workspace/node_modules/@babel/runtime/helpers/toConsumableArray.js");
// TODO: Write tests for this?
// TODO: Write README entry for this?
// TODO: https://github.com/Losant/omnibelt/issues/40
// NOTE: See `string-to-boolean` tests for example usage.

var curry = require('ramda/src/curry');
var compose = require('ramda/src/compose');
var evolve = require('ramda/src/evolve');
var map = require('ramda/src/map');
var format = require('./format');
var stringify = require('./stringify');
var testCaseToString = compose(format('({args}) => {expected}'), evolve({
  args: map(stringify),
  expected: stringify
}));

// testHarness :: Expect -> Function -> [*] -> *
var testHarness = curry(function (expect, fn, args, expected) {
  it(testCaseToString({
    args: args,
    expected: expected
  }), function () {
    return expect(fn.apply(void 0, _toConsumableArray(args))).toEqual(expected);
  });
});
module.exports = testHarness;